import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const vercel = defineConnector({
  identifier: "vercel",
  name: "Vercel",
  tagLine: "Frontend deployment platform",
  keywords: "zeit now nextjs hosting deployments serverless edge functions",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api\\.vercel\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create an access token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [Vercel Account Settings](https://vercel.com/account/tokens) and create a new token.\n\nGive it a descriptive name and select the appropriate scope for your use case.",
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "input",
          label: "Access token",
          placeholder: "Your Vercel access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.vercel.com/v10/projects",
  },
});
